/**
 * @generated SignedSource<<ba1a8ac8d2edc4a8a94916d6a8139f72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useReportTaxonomyQuery$variables = {
  reportType?: string | null;
};
export type useReportTaxonomyQuery$data = {
  readonly viewer: {
    readonly reportTaxonomy: string | null;
  } | null;
};
export type useReportTaxonomyQuery = {
  variables: useReportTaxonomyQuery$variables;
  response: useReportTaxonomyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportType"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "reportType",
      "variableName": "reportType"
    }
  ],
  "kind": "ScalarField",
  "name": "reportTaxonomy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportTaxonomyQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportTaxonomyQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72dca978da78861acfb938e57600eef1",
    "id": null,
    "metadata": {},
    "name": "useReportTaxonomyQuery",
    "operationKind": "query",
    "text": "query useReportTaxonomyQuery(\n  $reportType: String\n) {\n  viewer {\n    reportTaxonomy(reportType: $reportType)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a871cc6c1b7b7458fe2fbedcd9f9627";

export default node;
